import { Select, MenuItem, Switch, FormControlLabel, Box, Typography, Divider } from '@mui/material';
import FieldWrapper from '../FieldWrapper';
import AddressFields from '../AddressFields';

const TIPO_ABITAZIONE = ['Proprietà', 'Proprietà con Mutuo', 'Affitto', 'Presso Parenti', 'Presso Terzi'];

export default function Step4Residenza({ data, onChange, errors, metadata }) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Box>
        <Typography variant="h6" sx={{ fontWeight: 600, color: 'text.primary' }}>
          Dove vivi
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>
          Inserisci il tuo indirizzo di residenza
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Typography variant="overline" sx={{ fontWeight: 700, color: 'text.secondary', letterSpacing: 1 }}>
          Residenza
        </Typography>
        <AddressFields prefix="residenza" data={data} onChange={onChange} errors={errors} metadata={metadata} required />

        <FieldWrapper label="Tipo di abitazione" error={errors?.tipo_abitazione} completed={!!data.tipo_abitazione}>
          <Select 
            fullWidth 
            size="small" 
            value={data.tipo_abitazione || ''} 
            onChange={e => onChange('tipo_abitazione', e.target.value)}
            displayEmpty
          >
            <MenuItem value="" disabled>Seleziona tipo abitazione</MenuItem>
            {TIPO_ABITAZIONE.map(opt => (
              <MenuItem key={opt} value={opt}>{opt}</MenuItem>
            ))}
          </Select>
        </FieldWrapper>
      </Box>

      <Divider />

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Box sx={{ p: 1.5, bgcolor: 'action.hover', borderRadius: 3 }}>
          <FormControlLabel
            control={
              <Switch 
                checked={data.cambio_residenza_recente || false} 
                onChange={e => onChange('cambio_residenza_recente', e.target.checked)} 
              />
            }
            label={<Typography variant="body2">Hai cambiato residenza negli ultimi 3 anni?</Typography>}
            sx={{ m: 0, cursor: 'pointer' }}
          />
        </Box>
        {data.cambio_residenza_recente && (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
            <Typography variant="overline" sx={{ fontWeight: 700, color: 'text.secondary', letterSpacing: 1 }}>
              Indirizzo precedente
            </Typography>
            <AddressFields prefix="prev" data={data} onChange={onChange} errors={errors} metadata={metadata} />
          </Box>
        )}
      </Box>

      <Divider />

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Box sx={{ p: 1.5, bgcolor: 'action.hover', borderRadius: 3 }}>
          <FormControlLabel
            control={
              <Switch 
                checked={data.domicilio_diverso || false} 
                onChange={e => onChange('domicilio_diverso', e.target.checked)} 
              />
            }
            label={<Typography variant="body2">Il domicilio è diverso dalla residenza?</Typography>}
            sx={{ m: 0, cursor: 'pointer' }}
          />
        </Box>
        {data.domicilio_diverso && (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
            <Typography variant="overline" sx={{ fontWeight: 700, color: 'text.secondary', letterSpacing: 1 }}>
              Domicilio
            </Typography>
            <AddressFields prefix="domicilio" data={data} onChange={onChange} errors={errors} metadata={metadata} />
          </Box>
        )}
      </Box>
    </Box>
  );
}